import marketCarts from 'Assets/js/Vuex/Store/stores/marketCarts';

const mutations = {
  addB2bMarketCheckoutUrl(state, input) {
    const market = input.market.toLowerCase();
    state.b2bCarts.marketCarts[market].checkoutUrl = input.checkoutUrl;
  },
  addB2bMarketCheckoutStatus(state, input) {
    const market = input.market.toLowerCase();
    state.b2bCarts.marketCarts[market].order.status = input.checkoutStatus;
  },
  setB2bMarketCartOrderId(state, input) {
    const market = input.market.toLowerCase();
    state.b2bCarts.marketCarts[market].order.id = input.orderId;
  },
  setB2bMarketCartArbitraryCartId(state, input) {
    const market = input.market.toLowerCase();
    state.b2bCarts.marketCarts[market].arbitraryCartId = input.arbitraryCartId;
  },
  setGlobalGiftMessage(state, input) {
    state.b2bCarts.global.giftMessage = input;
  },
  setOrderStatus(state, input) {
    if (input.status === 'PAID') {
      state.b2bCarts.marketCarts[input.market] = marketCarts[input.market];
    }
    state.b2bCarts.marketCarts[input.market].order.status = input.status;
  },
  setB2bOrders(state, input) {
    // @todo They are both referenced by getters (b2b.orders and user.b2b.orders) --> to be fixed
    state.b2b.orders = input;
    state.user.b2b.orders = input;
  },
  setB2bTotalOrders(state, input) {
    // @todo They are both referenced by getters (b2b.orders and user.b2b.orders) --> to be fixed
    state.b2b.totalOrders = input;
    state.user.b2b.totalOrders = input;
  },
  setB2bOrderPagination(state, input) {
    // @todo They are both referenced by getters (b2b.orders and user.b2b.orders) --> to be fixed
    state.b2b.orderPagination = input;
    state.user.b2b.orderPagination = input;
  },
  setB2bCartTotals(state, input) {
    state.b2bCarts.marketCarts[input.market].total = input.totals.total;
  },
  purgeMarket(state, market) {
    state.b2bCarts.marketCarts[market] = {
      arbitraryCartId: '',
      cartDate: '',
      cartId: '',
      checkoutUrl: '',
      companyContactId: '',
      companyId: '',
      companyLocationId: '',
      contactItems: {},
      initiated: false,
      order: {},
      productQuantity: 0,
      recipientsQuantity: 0,
      shipping: 0,
      tax: 0,
      total: 0
    };
    state.b2bCarts.markets = state.b2bCarts.markets.filter(
      (m) => m !== market.toUpperCase()
    );
  },
  setB2bApiCartHash(state, input) {
    state.b2bApiCartHash = input;
  },
  appendB2bGlobalRecipients(state, recipients) {
    const key = recipients.productId;

    const filteredUsers = recipients.users.filter(
      (recipient) => recipient?.lineitem?.quantity !== 0
    );

    if (key === undefined) {
      return;
    }

    const newState = {
      ...state,
      b2bCarts: {
        ...state.b2bCarts,
        global: {
          ...state.b2bCarts.global,
          products: {
            ...state.b2bCarts.global.products,
            [key]: {
              ...state.b2bCarts.global.products[key],
              recipients: { ...state.b2bCarts.global.products[key].recipients }
            }
          }
        }
      }
    };

    filteredUsers.forEach((user) => {
      newState.b2bCarts.global.products[key].recipients[user.id] = user;
    });

    state.b2bCarts = newState.b2bCarts;
  },

  updateProductInMarketCart(state, input) {
    const market = input.market.toLowerCase();
    const newQuantity = input.quantity;

    const newState = {
      ...state,
      b2bCarts: {
        ...state.b2bCarts,
        marketCarts: {
          ...state.b2bCarts.marketCarts,
          [market]: {
            ...state.b2bCarts.marketCarts[market],
            contactItems: {
              ...state.b2bCarts.marketCarts[market].contactItems
            }
          }
        }
      }
    };

    // Iterate over each item in contactItems
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const itemKey in newState.b2bCarts.marketCarts[market].contactItems) {
      // eslint-disable-next-line no-restricted-syntax
      for (const productKey in newState.b2bCarts.marketCarts[market]
        .contactItems[itemKey].products) {
        if (
          newState.b2bCarts.marketCarts[market].contactItems[itemKey].products[
            productKey
          ].productId === input.productId
        ) {
          newState.b2bCarts.marketCarts[market].contactItems[itemKey].products[
            productKey
          ].quantity = newQuantity;
        }
      }
    }

    state.b2bCarts.marketCarts[market] = newState.b2bCarts.marketCarts[market];
  },

  updateProductInGlobalCart(state, input) {
    const newQuantity = input.quantity;
    const key = input.productId;

    const newState = {
      ...state,
      b2bCarts: {
        ...state.b2bCarts,
        global: {
          ...state.b2bCarts.global,
          products: {
            ...state.b2bCarts.global.products,
            [key]: {
              ...state.b2bCarts.global.products[key],
              products: {
                ...state.b2bCarts.global.products[key].products
              }
            }
          }
        }
      }
    };

    newState.b2bCarts.global.products[key].products.quantity = newQuantity;
    if (newState.b2bCarts.global.products[key]?.recipients) {
      Object.values(newState.b2bCarts.global.products[key].recipients).map(
        // eslint-disable-next-line array-callback-return
        (recipient) => {
          recipient.lineitem.quantity = newQuantity;
        }
      );
    }
    state.b2bCarts.global.products = newState.b2bCarts.global.products;
  },

  resetMarketCartOrder(state, market) {
    state.b2bCarts.marketCarts[market].total = 0;
    state.b2bCarts.marketCarts[market].order = {
      createdAt: '',
      id: '',
      status: 'preprocessing'
    };
  },
  setB2bUserCartTotal(state, input) {
    const market = input.market.toLowerCase();
    const { userId, total } = input;

    const newState = {
      ...state,
      b2bCarts: {
        ...state.b2bCarts,
        marketCarts: {
          ...state.b2bCarts.marketCarts,
          [market]: {
            ...state.b2bCarts.marketCarts[market],
            contactItems: {
              ...state.b2bCarts.marketCarts[market].contactItems,
              [userId]: {
                ...state.b2bCarts.marketCarts[market].contactItems[userId],
                total
              }
            }
          }
        }
      }
    };

    state.b2bCarts.marketCarts[market] = newState.b2bCarts.marketCarts[market];
  },
  setB2bUserCartShippingCost(state, input) {
    const market = input.market.toLowerCase();
    const { id, shipping } = input;

    const newState = {
      ...state,
      b2bCarts: {
        ...state.b2bCarts,
        marketCarts: {
          ...state.b2bCarts.marketCarts,
          [market]: {
            ...state.b2bCarts.marketCarts[market],
            contactItems: {
              ...state.b2bCarts.marketCarts[market].contactItems,
              [id]: {
                ...state.b2bCarts.marketCarts[market].contactItems[id],
                shipping
              }
            }
          }
        }
      }
    };

    state.b2bCarts.marketCarts[market] = newState.b2bCarts.marketCarts[market];
  }
};

export default mutations;
